import React, { useEffect, useState } from 'react'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import { useForm, Controller } from 'react-hook-form'
import TextInput from '../../../components/input/textinput/TextInput';
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import styles from './EditProfile.styles'
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown'
import { countryCodes } from '../../../components/countrycodes/countrycodesdata'
import Button from '../../../components/button/Button'
import { BUTTON_TYPE } from '../../../components/button/constants'
import { componentKey as AuthenticationComponentKey, setSignedInUser } from "../../authentication/AuthenticationSlice"
import { componentKey, setUserInfo, setSelectedCountry, setResetForm } from './EditProfileSlice';
import { useSelector, useDispatch } from 'react-redux';
import { USER_TYPE } from '../../../../libs/customhooks/constants';
import { useUserTypeInfo } from '../../../../libs/customhooks/useUserTypeInfo';
import Loadable from '../../../components/loadable/Loadable';
import { updateUserProfile } from './EditProfileSaga';
import { ACCOUNT_NAME, COMPANY_NAME, COMPANY_NAME_TITLE, COUNTRY_CODE_TITLE, EDIT_PROFILE_TITLE, EMAIL_ADDRESS_NAME, EMAIL_ADDRESS_NAME_TITLE, FIRST_NAME, FIRST_NAME_TITLE, LAST_NAME, LAST_NAME_TITLE, PHONE_NAME, PHONE_NAME_TITLE } from './constants';
import ConfirmationPopup from '../../../components/popup/confirmationpopup/ConfirmationPopup';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import { setShowChangePlan } from '../../dashboard/DashboardSlice';
import General from '../../../../libs/utility/General';
import { PAGE_STATE, PAGE_STATE_MESSAGE_MAP } from '../../constants/constants';

function EditProfile() {
    useGarbageCollector(componentKey)
    
	const { register, control, handleSubmit, watch, formState: { errors }, reset } = useForm();
	const { signedInUser } = useSelector((state) => state[AuthenticationComponentKey])
	const dispatch = useDispatch();
	const [isEditing, setIsEditing] = useState(false);
	const { userInfo, loadingState, changeProfileInfo, editEmail, selectedCountry, resetForm } = useSelector((state) => state[componentKey])
	const [showConfirmationPopup, setShowConfirmationPopup] = useState(false)

	const { userType } = useUserTypeInfo();

	useEffect(() => {
		dispatch(setUserInfo({
			Email: signedInUser.Email,
			FirstName: signedInUser.FirstName,
			LastName: signedInUser.LastName,
			CountryCode: signedInUser.CountryCode,
			PhoneNumber: signedInUser.PhoneNumber,
			CompanyName: signedInUser.CompanyName
		}))
		dispatch(setSelectedCountry(countryCodes.find(code => code.value === signedInUser.CountryCode)))
	}, [signedInUser])


	const handleInputChange = (e, onChangeValidationController) => {
		const { name, value } = e.target;
		onChangeValidationController(value);
		setIsEditing(true);
	}

	const handleEmailOnBlur = () => {

	}
	const validateEmail = (value) => {
		var validEmailRegex = /\S+@\S+\.\S+/;
		if (value.match(validEmailRegex)) {
			return true;
		}
		return 'Please enter a valid email';
	}

	const validateData = (e, onChange) => {
		General.validateInputWithRegex(e, () => handleInputChange(e, onChange))
	}

	const handleCountryCodeDropDownChange = (name, selectedOption) => {
		dispatch(setUserInfo({
			...userInfo,
			CountryCode: selectedOption.value,
		}))
		dispatch(setSelectedCountry(selectedOption))
		setIsEditing(true);
	}

	const handleCancel = () => {
		dispatch(setResetForm(true))
	}

	const handleFormSubmit = (value) => {
		if (value.Email !== userInfo.Email) {
			setShowConfirmationPopup(true)
			return;
		}
		updateProfile(value)
	}
    
	const updateProfile = (value) => {
		dispatch(updateUserProfile({...signedInUser,
			Email: value.Email,
			CompanyName: value.CompanyName,
			FirstName: value.FirstName,
			LastName: value.LastName,
			PhoneNumber: value.PhoneNumber,
			CountryCode: selectedCountry.value,
			userInfo: userInfo,
		}))
	}
	useEffect(()=>{
		if(resetForm){
			setIsEditing(false);
			reset({
				Email: signedInUser.Email, 
				CompanyName: signedInUser.CompanyName, 
				FirstName: signedInUser.FirstName, 
				LastName: signedInUser.LastName, 
				PhoneNumber: signedInUser.PhoneNumber
			});
			dispatch(setUserInfo({
				...userInfo,
				CountryCode: signedInUser.CountryCode,
			}))
			dispatch(setSelectedCountry(countryCodes.find(code => code.value === signedInUser.CountryCode)))
			dispatch(setResetForm(false))
		}
	},[resetForm])
	
	const handleEmailRest = (onChangeValidationController) => {
		onChangeValidationController(userInfo.Email);
	}
	const confirmEmailChange = () => {
		const { Email, CompanyName, FirstName, LastName, PhoneNumber } = watch();
		setShowConfirmationPopup(false);
		updateProfile({ Email, CompanyName, FirstName, LastName, PhoneNumber })
	}

	return (
		userInfo.Email === undefined ? null :
			<Loadable currentState={loadingState.state} loadingStates={[PAGE_STATE.LOADING]} messageMap={PAGE_STATE_MESSAGE_MAP} isNewLoadable={true}>
				<Heading type={HEADING.H1}>{EDIT_PROFILE_TITLE}</Heading>
				<div style={styles.mainContainer}>
					<div style={styles.formContainer}>
						<div style={styles.formFieldRow}>
							<div style={styles.formFieldContainer}>
								<span>{FIRST_NAME_TITLE}</span>
								<Controller
									control={control}
									name={FIRST_NAME}
									shouldUnregister={true}
									defaultValue={signedInUser.FirstName}
									rules={{
										required: "First name cannot be empty",
									}}
									render={({ field: { value, onChange } }) => (
										<TextInput
											type={'text'}
											placeHolder={FIRST_NAME_TITLE}
											name={FIRST_NAME}
											value={value}
											onChangeCb={(e) => validateData(e, onChange)}
										/>
									)}
								/>
								{errors.FirstName && <span style={styles.errorMessage}>{errors.FirstName.message}</span>}
							</div>
							<div style={styles.formFieldContainer}>
								<span>{LAST_NAME_TITLE}</span>
								<Controller
									control={control}
									name={LAST_NAME}
									shouldUnregister={true}
									defaultValue={signedInUser.LastName}
									rules={{
										required: "Last name cannot be empty",
									}}
									render={({ field: { value, onChange } }) => (
										<TextInput
											type={'text'}
											placeHolder={LAST_NAME_TITLE}
											name={LAST_NAME}
											value={value}
											onChangeCb={(e) => validateData(e, onChange)}
										/>
									)}
								/>
								{errors.LastName && <span style={styles.errorMessage}>{errors.LastName.message}</span>}
							</div>
						</div>
						<div style={styles.formFieldRow}>
							<div style={styles.formFieldContainer}>
								<span>{COMPANY_NAME_TITLE}</span>
								<Controller
									control={control}
									name={COMPANY_NAME}
									shouldUnregister={true}
									defaultValue={signedInUser.CompanyName}
									rules={{
										required: "Company cannot be empty",
									}}
									render={({ field: { value, onChange } }) => (
										<TextInput
											type={'text'}
											placeHolder={COMPANY_NAME_TITLE}
											name={COMPANY_NAME}
											value={value}
											onChangeCb={(e) => validateData(e, onChange)}
										/>
									)}
								/>
								{errors.CompanyName && <span style={styles.errorMessage}>{errors.CompanyName.message}</span>}
							</div>
							<div style={styles.formFieldContainer}>
								<span>{ACCOUNT_NAME}</span>
								<Controller
									control={control}
									name={ACCOUNT_NAME}
									defaultValue={userType}
									rules={{
										required: "Account cannot be empty",
									}}
									render={({ field: { value, onChange } }) => (
										<TextInput
											disabled={true}
											customStyles={styles.cursorDefault}
											type={'text'}
											placeHolder={ACCOUNT_NAME}
											name={ACCOUNT_NAME}
											value={value}
											onChangeCb={(e) => handleInputChange(e, onChange)}
										> 
										{ General.hasAccessToUserType( userType, [USER_TYPE.ESSENTIAL_USER, USER_TYPE.EFILE_PLUS_USER]) &&
										<Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} style={styles.rightPadding} onClickCb={()=> dispatch(setShowChangePlan(true))}>UPGRADE</Button>}</TextInput>		
									)}
								/>
								{errors.lastName && <span style={styles.errorMessage}>{errors.lastName.message}</span>}
							</div>
						</div>
						<div style={styles.formFieldRow}>
							<div style={styles.formFieldContainer}>
								<span>{EMAIL_ADDRESS_NAME_TITLE}</span>
								<div style={styles.emailInputRow}>
									<Controller
										control={control}
										name={EMAIL_ADDRESS_NAME}
                                        shouldUnregister={true}
										defaultValue={signedInUser.Email}
										rules={{
											required: "Email cannot be empty",
											validate: validateEmail
										}}
										render={({ field: { value, onChange } }) => (
											<TextInput
												type={'text'}
												placeHolder={'Email'}
												name={EMAIL_ADDRESS_NAME}
												confirmedEdit={true}
												value={value}
												onReset={(e) => handleEmailRest(onChange)}
												onChangeCb={(e) => handleInputChange(e, onChange)}
												onBlurCb={(e) => handleEmailOnBlur(e)}
											/>
										)}
									/>
								</div>
								{errors.Email && <span style={styles.errorMessage}>{errors.Email.message}</span>}
							</div>
							<div style={styles.formFieldContainer}>
								<div style={{...styles.formInputRow, ...styles.heightFull}}>
									<div style={{...styles.flexOne, ...styles.flexCol}}>
									<span>{COUNTRY_CODE_TITLE}</span>
										<SelectDropdown
											name="CountryCode"
											value={{ label: selectedCountry.value, value: selectedCountry.value }}
											prefixProps={{ text: "" }}
											isClearable={false}
											onSelectCb={(name, selectedOption) => handleCountryCodeDropDownChange(name, selectedOption)}
											options={countryCodes.map(option => ({label: option.value, value: option.value}))}
											inputType='number'
										/>
									</div>
									<div style={{...styles.flexOne, ...styles.flexCol}}>
									<span>{PHONE_NAME_TITLE}</span>
										<Controller
											control={control}
											name={PHONE_NAME}
											shouldUnregister={true}
											defaultValue={signedInUser.PhoneNumber}
											rules={{
												required: "Phone number cannot be empty",
											}}
											render={({ field: { value, onChange } }) => (
												<TextInput
													type={'text'}
													placeHolder={PHONE_NAME_TITLE}
													name={PHONE_NAME}
													value={value}
													onChangeCb={(e) => validateData(e, onChange)}
												/>
											)}
										/>
									</div>
								</div>
								{errors.PhoneNumber && <span style={styles.errorMessage}>{errors.PhoneNumber.message}</span>}
							</div>
						</div>
						<div style={styles.buttonRows}>
							<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} style={styles.buttonPadding} disabled={!isEditing} onClickCb={handleCancel}>Cancel</Button>
							<Button type={BUTTON_TYPE.PRIMARY} style={styles.buttonPadding} disabled={!isEditing} onClickCb={handleSubmit(handleFormSubmit)}>Save Profile</Button>
						</div>
					</div>
				</div>
				<ConfirmationPopup
					title={"Please Note"}
					bodyText={"This will change the email for your account and you will be logged out. Would you like to change your email ID? "}
					iconName={VEC_ICON_NAME.WARNING_ICON}
					isOpen={showConfirmationPopup}
					confirmationButtonProps={{
						onConfirmationCb: () => confirmEmailChange(),
						confirmationButtonText: "Confirm",
						confirmationButtonStyles: {},
						confirmationButtonType: BUTTON_TYPE.PRIMARY,
					}}
					cancelButtonProps={{
						onCancelCb: () => setShowConfirmationPopup(false),
						cancelButtonText: "Cancel",
						cancelButtonStyles: {},
						cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
					}}
					showClose={false}
				/>
			</Loadable>
	)
}

export default EditProfile